import forOwn from "lodash/forOwn";
import { AppointmentBase, AppointmentPractitionerBase, CancellationInfoBase } from "@backend/graph/appointments/appointment-base";
import { BookableAppointmentPractitionerEntry } from "./bookable-appointment";

export interface I_SelectedAppointmentSlot {
  name: string;
  site_id: string;
  site_name: string;
  site_address_line_1: string;
  site_address_line_2: string;
  site_address_line_3: string;
  site_county: string;
  site_postcode: string;
  start_time: Date;
  duration: number;
  practitioner: BookableAppointmentPractitionerEntry;
  practitioners: Array<BookableAppointmentPractitionerEntry>;
  appointment_type_id: string;
  appointment_type_reason: string;
  site_appointment_type_id: string;
  reason: string;
}

export class CancellationInfoEntry extends CancellationInfoBase {}

export class AppointmentPractitionerEntry extends AppointmentPractitionerBase {
  constructor(baseItem?: AppointmentPractitionerBase) {
    super();
    if (!baseItem) return;
    forOwn(baseItem, (value, key) => {
      this[key] = value;
    });
  }
}

export class AppointmentEntry extends AppointmentBase {
  constructor(baseItem?: AppointmentBase) {
    super();
    if (!baseItem) return;
    forOwn(baseItem, (value, key) => {
      this[key] = value;
    });
  }
}

export class AllAppointmentsEntry {
  public future: Array<AppointmentEntry>;
  public past: Array<AppointmentEntry>;
}
export enum E_AppointmentEventActions {
  APPOINTMENTS_OPEN_FOR_CHECKIN = "APPOINTMENTS_OPEN_FOR_CHECKIN",
  SUCCESSFULLY_ADDED_COMMENT = "SUCCESSFULLY_ADDED_COMMENT",
  ERROR_ADDING_COMMENT = "ERROR_ADDING_COMMENT",
  APPOINTMENTS_UPDATED = "APPOINTMENTS_UPDATED",
  SLOT_SELECTED = "SLOT_SELECTED",
  SLOT_UNAVAILABLE = "SLOT_UNAVAILABLE",
  BOOKING_APPOINTMENTS = "BOOKING_APPOINTMENTS",
  CHECKING_BOOKING_SESSION = "CHECKING_BOOKING_SESSION",
  BOOKING_SESSION_OK = "BOOKING_SESSION_OK",
}
export class AppointmentEvents {
  public action: E_AppointmentEventActions;
  public appointments?: Array<AppointmentEntry>;
  public slots?: Array<I_SelectedAppointmentSlot>;
}
